import { Button } from "src/components/MuiGenerals";
import { useDialogProviderContext } from "src/features/DialogProvider";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";

function AddLedgerBalanceMonitorButton() {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const { setIsOpen } = useDialogProviderContext();

  return (
    <Button
      children={t("add_ledger_balance_monitor")}
      variant="outlined"
      onClick={() => setIsOpen(true)}
    />
  );
}

export default AddLedgerBalanceMonitorButton;
